import { withChildren } from '@builder.io/react';
import { PropsWithChildren } from 'react';

const Container: React.FC<PropsWithChildren> = ({ children }) => {
  return <div className="tc-container">{children}</div>;
};

export default withChildren(Container);
